<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout class="text-xs-left ml-2 mr-2 mt-4">
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> today </v-icon>
            </v-avatar>
            Maintennace Call Dates
          </v-chip>
          <v-spacer/>
        </v-layout>
        <v-layout row wrap class="mr-2">
          <v-flex xs10 sm5 lg5 offset-xs2 offset-sm2 offset-lg1>
            <v-text-field
            :label='dateTypeA(this.getDetailStats.dplan)'
            prepend-icon="event"
            hint="call plan date"
            persistent-hint
            readonly
            outline
            ></v-text-field>
          </v-flex>
          <v-flex xs10 sm5 lg5 offset-xs2 offset-sm2 offset-lg0>
            <v-text-field
            :label='dateTypeA(this.getDetailStats.ddue)'
            prepend-icon="event_available"
            hint="call due date"
            persistent-hint
            readonly
            outline
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
// import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [apptheme, dateFunctions],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar", "getDetailStats"])
  }
};
</script>
